import React from 'react';
import { Button } from '../components/Button';
import { VideoEmbed } from '../components/VideoEmbed';
import { Check, Phone, Mail } from 'lucide-react';
export function HomePage() {
  const benefits = ['Build real strength and functional fitness', 'Learn authentic kickboxing techniques', 'Develop mental toughness and discipline', 'Get personalized training tailored to your goals', 'Train in English in central Warsaw', 'Flexible scheduling that works for you'];
  return <main className="flex-grow bg-black" data-id="element-150">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="max-w-5xl mx-auto text-center space-y-8" data-id="element-152">
          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" data-id="element-153">
            Transform Your Body With{' '}
            <span className="text-[#D4FF00]" data-id="element-154">1-on-1 Kickboxing</span> &{' '}
            <span className="text-[#D4FF00]" data-id="element-155">Fitness Training</span> in Warsaw
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-156">
            Professional martial arts coaching designed to help you{' '}
            <span className="text-[#D4FF00] font-bold" data-id="element-157">build strength</span>,{' '}
            <span className="text-[#D4FF00] font-bold" data-id="element-158">lose weight</span>, and{' '}
            <span className="text-[#D4FF00] font-bold" data-id="element-159">gain confidence</span>
          </p>

          {/* Video */}
          <div className="max-w-4xl mx-auto mt-12" data-id="element-160">
            <VideoEmbed videoId="dQw4w9WgXcQ" title="Training Overview" autoplay={true} data-id="element-161" />
          </div>

          {/* CTA */}
          <div className="pt-8 space-y-4" data-id="element-162">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-163">
              <Button variant="primary" size="lg" href="tel:+48536052998" className="text-lg" data-id="element-164">
                <Phone className="w-5 h-5 mr-2" data-id="element-165" />
                Book Free Consultation
              </Button>
              <Button variant="secondary" size="lg" href="mailto:contact@szulcaleks.com" className="text-lg" data-id="element-166">
                <Mail className="w-5 h-5 mr-2" data-id="element-167" />
                Email Me
              </Button>
            </div>
            <p className="text-sm text-gray-400" data-id="element-168">
              📞 Free consultation call • 💪 Discounted first session
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-gray-900" data-id="element-169">
        <div className="max-w-4xl mx-auto" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4" data-id="element-171">
            What You'll Get From Training
          </h2>
          <p className="text-gray-400 text-center mb-12 text-lg" data-id="element-172">
            Personalized coaching focused on your goals
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-173">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-4 bg-gray-900/50 border border-gray-800 rounded-xl p-6 hover:border-[#D4FF00]/30 transition-colors" data-id="element-174">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#D4FF00] flex items-center justify-center mt-1" data-id="element-175">
                  <Check className="w-4 h-4 text-black" strokeWidth={3} data-id="element-176" />
                </div>
                <span className="text-gray-200 text-lg leading-relaxed" data-id="element-177">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-800" data-id="element-178">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-179">
          <div className="w-48 h-48 flex-shrink-0 rounded-full overflow-hidden border-4 border-[#D4FF00]" data-id="element-180">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Aleks Szulc" className="w-full h-full object-cover" data-id="element-181" />
          </div>
          <div className="text-center md:text-left space-y-4" data-id="element-182">
            <h2 className="text-3xl font-bold text-white" data-id="element-183">Hi, I'm Aleks</h2>
            <p className="text-gray-300 leading-relaxed text-lg" data-id="element-184">
              I'm a martial artist and fitness coach based in Warsaw. My mission
              is to help you achieve your fitness goals through personalized
              kickboxing and strength training. Whether you want to lose weight,
              build muscle, or learn self-defense, I'm here to guide you every
              step of the way.
            </p>
            <Button variant="outline" href="/about" data-id="element-185">
              Learn More About Me
            </Button>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-gray-900 via-black to-gray-900 border-t border-gray-800" data-id="element-186">
        <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-187">
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight" data-id="element-188">
            Ready To Start Your Training Journey?
          </h2>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-189">
            Book a free consultation call to discuss your goals and see if we're
            a good fit
          </p>

          <div className="pt-4 space-y-4" data-id="element-190">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-191">
              <Button variant="primary" size="lg" href="tel:+48536052998" className="text-lg" data-id="element-192">
                <Phone className="w-5 h-5 mr-2" data-id="element-193" />
                Call Now: +48 536 052 998
              </Button>
            </div>
            <p className="text-sm text-gray-400" data-id="element-194">
              ✅ Free consultation • 💪 Discounted first training session
            </p>
          </div>
        </div>
      </section>
    </main>;
}